import { activeInvoices } from "./invoicesGroup";
import { activeQuotes } from "./quotesGroup";

function money(doc: Record<string, unknown>, key: string): number {
  const n = Number(doc?.[key]);
  return Number.isFinite(n) ? n : 0;
}

function sortByDateThenNumber(
  a: Record<string, unknown>,
  b: Record<string, unknown>,
  dateKey: string,
  numberKey: string
) {
  const da = String(a[dateKey] || "");
  const db = String(b[dateKey] || "");
  if (da !== db) return db.localeCompare(da);
  return Number(b[numberKey] || 0) - Number(a[numberKey] || 0);
}

export function invoicesForCustomer(
  invoices: Record<string, Record<string, unknown>> | null | undefined,
  customerName: string
): Record<string, unknown>[] {
  const name = String(customerName || "").trim();
  if (!name) return [];
  return activeInvoices(invoices)
    .filter((inv) => String(inv.customer_name || "") === name)
    .sort((a, b) => sortByDateThenNumber(a, b, "invoice_date", "invoice_number"));
}

export function quotesForCustomer(
  quotes: Record<string, Record<string, unknown>> | null | undefined,
  customerName: string
): Record<string, unknown>[] {
  const name = String(customerName || "").trim();
  if (!name) return [];
  return activeQuotes(quotes)
    .filter((q) => String(q.customer_name || "") === name)
    .sort((a, b) => sortByDateThenNumber(a, b, "quote_date", "quote_number"));
}

export interface CustomerStats {
  invoiceCount: number;
  outstandingIncGst: number;
  paidIncGst: number;
  lastInvoiceDate: string;
}

export function customerStats(
  invoices: Record<string, Record<string, unknown>> | null | undefined,
  customerName: string
): CustomerStats {
  const items = invoicesForCustomer(invoices, customerName);
  let outstandingIncGst = 0;
  let paidIncGst = 0;
  let lastInvoiceDate = "";
  for (const inv of items) {
    const amount = money(inv, "total_inc_gst");
    const status = String(inv.status || "not_sent");
    if (status === "sent") outstandingIncGst += amount;
    else if (status === "paid") paidIncGst += amount;
    const d = String(inv.invoice_date || "");
    if (d && d > lastInvoiceDate) lastInvoiceDate = d;
  }
  return {
    invoiceCount: items.length,
    outstandingIncGst,
    paidIncGst,
    lastInvoiceDate,
  };
}
